import factory from '../../../store/factory'

export default {
  scan_reports: factory('ScanReports')
}